import axios from 'axios';
import get from 'lodash/get';
import { fetchStripeCustomer } from './stripeCustomerActions';

export const STRIPE_CARD_LOADING = 'STRIPE_CARD_LOADING';
export const STRIPE_CARD_SUCCESS = 'STRIPE_CARD_SUCCESS';
export const STRIPE_CARD_ERROR = 'STRIPE_CARD_ERROR';

export const STRIPE_CARD_EDIT_LOADING = 'STRIPE_CARD_EDIT_LOADING';
export const STRIPE_CARD_EDIT_ERROR = 'STRIPE_CARD_EDIT_ERROR';

export const STRIPE_CARD_ADD = 'STRIPE_CARD_ADD';
export const STRIPE_CARD_REMOVE = 'STRIPE_CARD_REMOVE';
export const STRIPE_CARD_SET_DEFAULT = 'STRIPE_CARD_SET_DEFAULT';

export function fetchStripeCards(customerId, callback) {
  return (dispatch) => {
    dispatch({ type: STRIPE_CARD_LOADING });

    axios
      .get(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/customers/${customerId}/sources?object=card&limit=100`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
          },
        }
      )
      .then((response) => {
        callback && callback();

        dispatch({
          type: STRIPE_CARD_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((result) => {
        dispatch({
          type: STRIPE_CARD_ERROR,
          payload: result.response.data,
        });
      });
  };
}

export const addStripeCardAsync = (
  customerId,
  token,
  shouldFetchCustomer = true
) => async (dispatch, getState) => {
  try {
    const state = getState();
    dispatch({ type: STRIPE_CARD_EDIT_LOADING });
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/stripe/customers/${customerId}/cards`,
      {
        token,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      }
    );

    if (shouldFetchCustomer) {
      dispatch(fetchStripeCustomer(customerId));
    }

    dispatch({
      type: STRIPE_CARD_ADD,
      payload: response.data.data,
    });

    return response.data.data;
  } catch (error) {
    const response = get(error, 'response.data');

    dispatch({
      type: STRIPE_CARD_EDIT_ERROR,
      payload: { error: response },
    });

    throw error;
  }
};

export function addStripeCard(
  customerId,
  token,
  callback,
  shouldFetchCustomer = true
) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: STRIPE_CARD_EDIT_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/stripe/customers/${customerId}/cards`,
        {
          token,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`,
          },
        }
      )
      .then((response) => {
        callback && callback();

        if (shouldFetchCustomer) {
          dispatch(fetchStripeCustomer(customerId));
        }

        dispatch({
          type: STRIPE_CARD_ADD,
          payload: response.data.data,
        });
      })
      .catch((result) => {
        dispatch({
          type: STRIPE_CARD_EDIT_ERROR,
          payload: { error: result.response.data },
        });
      });
  };
}

export function removeStripeCard(customerId, cardId, callback) {
  return (dispatch) => {
    dispatch({ type: STRIPE_CARD_EDIT_LOADING });

    axios
      .delete(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/customers/${customerId}/sources/${cardId}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
          },
        }
      )
      .then((response) => {
        callback && callback();

        dispatch(fetchStripeCustomer(customerId));

        dispatch({
          type: STRIPE_CARD_REMOVE,
          payload: response.data,
        });
      })
      .catch((result) => {
        dispatch({
          type: STRIPE_CARD_EDIT_ERROR,
          payload: result.response.data,
        });
      });
  };
}

export function setDefaultCard(customerId, cardId, callback) {
  return (dispatch) => {
    dispatch({ type: STRIPE_CARD_EDIT_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/customers/${customerId}`,
        `default_source=${cardId}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      )
      .then((response) => {
        callback && callback();

        dispatch(fetchStripeCustomer(customerId));

        dispatch({
          type: STRIPE_CARD_SET_DEFAULT,
          payload: response.data,
        });
      })
      .catch((result) => {
        dispatch({
          type: STRIPE_CARD_EDIT_ERROR,
          payload: result.response.data,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/stripeCardActions.js